// Partial — admin/news routes.
// Covers: /admin/news (BTC/ETH crypto-news curation + publish toggle).
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminNewsPage = lazyWithRetry(() => import("./pages/AdminNewsPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/news", Component: AdminNewsPage }],
  },
];

export default routes;
